module.exports = __webpack_public_path__ + "static/media/edit.cb2744a8.svg";